import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Flag, Trophy } from 'lucide-react';
export function Story() {
  const callouts = [{
    icon: <Sparkles size={24} data-id="element-191" />,
    title: 'Started at Age 3',
    desc: 'A lifetime of Taekwondo built on discipline and consistency.'
  }, {
    icon: <Flag size={24} data-id="element-192" />,
    title: 'Competing Nationally',
    desc: 'Training and competing against top athletes across the U.S.'
  }, {
    icon: <Trophy size={24} data-id="element-193" />,
    title: 'Team USA & Olympic Goals',
    desc: 'Working toward USAT Nationals, Team USA, and the Olympic dream.'
  }];
  return <section id="story" className="py-20 lg:py-28 bg-white" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-center mb-16" data-id="element-196">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative lg:col-span-2" data-id="element-197">
            <div className="relative aspect-[4/5] w-full" data-id="element-198">
              {/* Decorative accents */}
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-usa-red z-0" data-id="element-199" />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-usa-gold z-0" data-id="element-200" />

              <img src="https://cdn.magicpatterns.com/uploads/nNYj9Neju3rCoKc4PomuDf/image.png" alt="Cyrus Barbour competing in Taekwondo" className="relative z-10 w-full h-full object-cover border-4 border-usa-navy shadow-2xl" data-id="element-201" />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-3" data-id="element-202">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-usa-navy mb-6 leading-tight" data-id="element-203">
              CYRUS BARBOUR'S{' '}
              <span className="text-usa-red" data-id="element-204">TAEKWONDO JOURNEY</span>
            </h2>
            <div className="w-16 h-1 bg-usa-red mb-8" data-id="element-205" />

            <div className="space-y-5 text-lg text-gray-700 leading-relaxed" data-id="element-206">
              <p data-id="element-207">
                Cyrus Barbour started Taekwondo when he was just three years
                old. What began as a childhood activity has grown into a serious
                athletic journey built on discipline, leadership, competition,
                and long-term goals.
              </p>
              <p data-id="element-208">
                As Cyrus continues to train and compete, the costs of high-level
                Taekwondo can add up quickly. Tournament entry fees, travel,
                equipment, training, and national-level competition expenses all
                become part of the journey. TKD Future helps make it easier for
                family, friends, local businesses, and community supporters to
                stand behind Cyrus as he works toward USAT Nationals, Team USA,
                and the Olympic dream.
              </p>
              <p data-id="element-209">
                Cyrus also enjoys teaching and being a role model for younger
                students. His journey is not only about medals or competition —
                it's about character, discipline, respect, leadership, and
                continuing to grow into the kind of athlete and person who can
                inspire others.
              </p>
              <p className="font-semibold text-usa-navy" data-id="element-210">
                His goals: win gold at USAT Nationals, earn a place on the USA
                Taekwondo Team, and continue toward the Olympic Games.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Supporting Callouts */}
        <div className="grid sm:grid-cols-3 gap-6 pt-8 border-t border-gray-200" data-id="element-211">
          {callouts.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4" data-id="element-212">
              <div className="bg-usa-navy text-usa-gold p-3 shrink-0" data-id="element-213">
                {item.icon}
              </div>
              <div data-id="element-214">
                <h3 className="font-display text-xl text-usa-navy mb-1 tracking-wide" data-id="element-215">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-216">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}